import {gql} from '@apollo/client'
import useOrganisation from 'bundles/admin/hooks/useOrganisation'
import React from 'react'
import {Fragment} from 'react'
import {useParams, NavLink} from 'react-router-dom'

export const QUERY = gql`
  query GetOrganisation {
    organisation {
      id
      featureFlags
      smsEnabled
      accountAlertsCount
      serviceAlertsCount
    }
  }
`

export default ({onSelect}) => {
  const {organisationID} = useParams()
  const {organisation} = useOrganisation(organisationID, {query: QUERY})

  if (!organisation) return null

  return (
    <Fragment>
      {organisation.featureFlags?.includes('dashboard') ? (
        <li>
          <NavLink exact to={`/orgs/${organisationID}`} aria-label='Dashboard' onClick={onSelect}>
            Dashboard
          </NavLink>
        </li>
      ) : null}

      <li>
        <div className='with-badge' style={{display: 'block'}}>
          <NavLink to={`/orgs/${organisationID}/accounts`} aria-label='Manage accounts' onClick={onSelect}>
            Accounts
          </NavLink>
          {organisation.accountAlertsCount > 0 ? (
            <span className='badge has-background-danger has-text-white' style={{border: 'none', right: 0}}>
              {organisation.accountAlertsCount}
            </span>
          ) : null}
        </div>
      </li>
      {organisation.featureFlags?.includes('internet_services') ? (
        <li>
          <div className='with-badge' style={{display: 'block'}}>
            <NavLink to={`/orgs/${organisationID}/services`} aria-label='Manage services' onClick={onSelect}>
              Services
            </NavLink>
            {organisation.serviceAlertsCount > 0 ? (
              <span className='badge has-background-danger has-text-white' style={{border: 'none', right: 0}}>
                {organisation.serviceAlertsCount}
              </span>
            ) : null}
          </div>
        </li>
      ) : null}
      <li>
        <NavLink aria-label='Manage invoices' to={`/orgs/${organisationID}/invoices`} onClick={onSelect}>
          Invoices
        </NavLink>
      </li>
      <li>
        <NavLink to={`/orgs/${organisationID}/payments`} aria-label='Reconcile payments' onClick={onSelect}>
          Payments
        </NavLink>
      </li>
      <li>
        <NavLink aria-label='Manage payment rules' to={`/orgs/${organisationID}/payment_rules`} onClick={onSelect}>
          Rules
        </NavLink>
      </li>
      <li>
        <NavLink aria-label='Manage groups' to={`/orgs/${organisationID}/groups`} onClick={onSelect}>
          Groups
        </NavLink>
      </li>
      {organisation.featureFlags?.includes('users') ? (
        <li>
          <NavLink aria-label='Manage users' to={`/orgs/${organisationID}/users`} onClick={onSelect}>
            Access
          </NavLink>
        </li>
      ) : null}
      <li>
        <a href={`/orgs/${organisationID}/reports`} aria-label='Download reports'>
          Reports
        </a>
      </li>
      {organisation.smsEnabled ? (
        <li>
          <NavLink aria-label='Manage text messages' to={`/orgs/${organisationID}/text_messages`}>
            Text messages
          </NavLink>
        </li>
      ) : null}
    </Fragment>
  )
}
